export const encryptionKeys = {
  IV: '9PLQTNVhJcRsbPTU',
  key: 'MKOIJNQASDFVRGHNBHUCFTXDRTTYUA'
};
